import React from 'react'
import { FigmaHero } from '../FigmaHero'
import { HeroContent } from '../Hero'
import { FiftyFifty, FigmaBlind, FigmaLucia } from '../../style'

const GameHero = ({
  isFigma,
  onGeneratePair,
  animationDisabled,
  onToggleAnimation,
}) => {
  if (isFigma) {
    return (
      <>
        <FigmaBlind />
        <FiftyFifty>
          <FigmaHero
            onClick={onGeneratePair}
            animationDisabled={animationDisabled}
            setAnimation={onToggleAnimation}
          />
        </FiftyFifty>
        <FigmaLucia />
      </>
    )
  }

  return (
    <FiftyFifty>
      <HeroContent onClick={onGeneratePair} />
    </FiftyFifty>
  )
}

export { GameHero }
